var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-wrapper"},[_vm._m(0),(_vm.progress !== null)?_c('div',{staticClass:"lds-progress"},[_vm._v(_vm._s(_vm.progress)+"%")]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-default"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }